import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../../styles/AppTheme';
import { CommonStyles } from '../../../styles/Styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { TableNumSelectComponent } from './TableNumSelectComponent';

export class TableNumVariant extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  renderHead() {
    const images = this.props.data.images
    return (
      <TableHead>
        <TableRow>
          <TableCell className={css(Styles.cellHeadIndex)}>
          </TableCell>
          {images.map((item, index) => (
            <TableCell
              className={css(Styles.cellHead)}
              key={'headCol' + index}>
              <div>
                <img
                  src={item}
                  className={css(Styles.imageContent)}
                />
              </div>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    )
  }


  renderBody() {
    return (
      <TableBody>
        {
          this.props.data.subQuestions.sort((a, b) => {
            return a.order - b.order;
          }),
          this.props.data.subQuestions.map((current, itemIndex) => {
            return (
              <TableRow key={current.id}>
                <TableCell className={css(Styles.cell)}>
                  <div>
                    <p className={css(CommonStyles.questionMainTitle, Styles.questionMainTitle)}>{current.title}</p>
                  </div>
                </TableCell>
                <TableNumSelectComponent
                  data={current}
                  handleState={this.props.handleState}
                  id={current.id}
                />
              </TableRow>
            )
          })
        }
      </TableBody >
    )
  }

  render() {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          {this.props.data.image &&
            <div className={css(Styles.headerImageContainer)}>
              <img
                src={this.props.data.image}
                className={css(Styles.headerImageContent)}
              />
            </div>
          }
          <Table className={css(Styles.table)}>
            {this.renderHead()}
            {this.renderBody()}
          </Table>
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    '@media (max-width: 767px)': {
      padding: 5,
    }
  },
  innerContainer: {
    overflowX: 'scroll',
    '@media (max-width: 767px)': {
      marginLeft: 10,
    }
  },
  formLabel: {
    fontSize: AppTheme.subTitleSize - 4,
    margin: 0,
    marginBottom: 10,
    color: AppTheme.primaryColor,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767 - 4,
    }
  },
  cellHeadIndex: {
    minWidth: 300
  },
  cellHead: {
    fontWeight: 'unset',
    color: 'unset',
    padding: 5,
    minWidth: 200,
    textAlign: 'center'
  },
  cell: {
    minWidth: 200,
  },
  questionMainTitle: {
    fontSize: AppTheme.subTitleSize - 4,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767 - 4,
    }
  },
  imageContent: {
    width: '100%'
  },
  headerImageContent: {
    maxWidth: '100%',
    maxHieght: '100%'
  },
  headerImageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/TableNum/TableNumVariant.js